module.exports = __webpack_public_path__ + "static/media/baseline-mail_outline-24px.527601ba.svg";